import { render, staticRenderFns } from "./Timetable.vue?vue&type=template&id=18822b56&scoped=true&lang=pug&"
import script from "./Timetable.vue?vue&type=script&lang=js&"
export * from "./Timetable.vue?vue&type=script&lang=js&"
import style0 from "./Timetable.vue?vue&type=style&index=0&id=18822b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18822b56",
  null
  
)

export default component.exports